import { tokens } from "@fluentui/react-components";
/**
 * Constant values used in styles
 */ /** Shadow constants */ export const ShadowMargin = "13px";
// every width has to include the width of the left nav in uno, which is 360px.
export const SmallScreenWidth = "1060px";
/** SuiteNav Header */ export const SuiteNavHeight = "48px";
// Scroll bar constants
export const ScrollBarWidth = tokens.spacingHorizontalMNudge;
export const ScrollBarHeight = tokens.spacingVerticalS;
export const ScrollBarBorderRadius = "5px";
// Evo Header styles
export const HeaderHeight = "58px";
export const HeaderPadding = tokens.spacingHorizontalXXXL;
export const HeaderBorderBottom = tokens.strokeWidthThin;
/** Border radius to use for all dialogs, dropdowns, cards, etc */ export const PlannerBorderRadius = "3px";
/** Board View */ export const ScrollbarSpaceAround = "10px";
/** Minimum height for scrollable view containers (board, calendar, etc.) to ensure usability on small screens */ export const ViewContainerMinHeight = "400px";
/**
 * Task Board View Constants
 * These constants are used to define the number of placeholder Task Cards
 * [5, 3, 4, 2] represents 4 columns in the boardView with having (5,3,4,2) as the number of Task Cards in each column
 */ /** Number of placeholder Task Cards for plan*/ export const PlanTaskCardPlaceHolders = [
    5,
    3,
    4,
    2
];
/** Number of placeholder Task Cards for my day and my task*/ export const MyDayMyTaskTaskCardPlaceHolders = [
    5,
    3,
    4
];
/** Plan Settings Panel Constants */ /** Standard navigation bar height in px */ export const NavigationBarMinHeight = "48px";
/** Standard button minimum size */ export const StandardButtonMinSize = tokens.spacingHorizontalXXXL;
/** Standard tab list minimum height */ export const TabListMinHeight = tokens.spacingHorizontalXXXL;
/** Media queries */ export const HighContrastMediaQuery = "(forced-colors: active), (-ms-high-contrast: active)";
/**
 * min - 320px
 * med - 640px
 * max - 1024px
 */ export const ResponsiveHeaderWidths = {
    maxWidth320: 320,
    maxWidth480: 480,
    maxWidth640: 640,
    maxWidth1024: 1024,
    maxWidth1536: 1536,
    maxWidth1920: 1920
};
/**
 * Responsive breakpoints for common screen sizes
 * Usage: `@media ${ResponsiveBreakpoints.small} { ... }`
 */ export const ResponsiveBreakpoints = {
    /** Extra small devices (up to 320px) */ xsmall: `(max-width: ${ResponsiveHeaderWidths.maxWidth320}px)`,
    /** Small devices (up to 480px) */ small: `(max-width: ${ResponsiveHeaderWidths.maxWidth480}px)`,
    /** Medium devices (up to 640px) */ medium: `(max-width: ${ResponsiveHeaderWidths.maxWidth640}px)`,
    /** Large devices (up to 1024px) */ large: `(max-width: ${ResponsiveHeaderWidths.maxWidth1024}px)`,
    /** Extra large devices (up to 1536px) */ xlarge: `(max-width: ${ResponsiveHeaderWidths.maxWidth1536}px)`,
    /** Extra extra large devices (up to 1920px) */ xxlarge: `(max-width: ${ResponsiveHeaderWidths.maxWidth1920}px)`
};
